import { useLocation, useNavigate, useParams } from "react-router-dom";

import React from "react";

// The functional component wrapper that provides location and navigate
const withRouter = (WrappedComponent) => {
  // This functional component is needed to use the hooks
  return function WithRouterWrapper(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    // Pass location and navigate down to the wrapped class component as props
    return (
      <WrappedComponent
        {...props}
        location={location}
        navigate={navigate}
        params={params}
      />
    );
  };
};

export default withRouter;
